import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../../theme';
export const tabActiveClassName = 'active';

export type PrimaryTabProps = PropsWithChildren<{
  activeClassName?: string;
  disabled?: boolean;
}>;

const StyledPrimaryTab = styled.li<PrimaryTabProps>`
  display: flex;
  margin: 0 ${theme.spacings[1].rem};
  min-width: 80px;
  text-align: center;

  &:first-child {
    margin-left: 0;
  }

  a {
    width: 100%;
    height: fit-content;
    transition: color 200ms ease-in, background-color 200ms ease-in;
    ${theme.typography.uiText.sm};
    color: ${({ disabled }) =>
      disabled
        ? theme.colors.neutrals.solidGrays[3]
        : theme.colors.primary.graysGray};
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    text-decoration: none;
    border-radius: 24px;
    padding: ${theme.spacings[2].rem} ${theme.spacings[3].rem};

    ${({ activeClassName, disabled }) =>
      !disabled &&
      `
    &.${activeClassName}, &:hover {
      background-color: ${theme.colors.primary.graysGray};
      color: ${theme.colors.primary.white};
      font-weight: 700;
    }`}

    ${breakpoint('md')`
      ${theme.typography.uiText.md}
    `}
  }

  ${breakpoint('lg')`
      min-width: 100px;
      
      a {
        padding: ${theme.spacings[2].rem} ${theme.spacings[4].rem};
      }
    `}
`;

export const PrimaryTab: React.FC<PrimaryTabProps> = ({
  activeClassName = tabActiveClassName,
  disabled = false,
  children,
}) => (
  <StyledPrimaryTab activeClassName={activeClassName} disabled={disabled}>
    {children}
  </StyledPrimaryTab>
);
